import { REGEX_URL, trim } from '@/utils';

export function websiteDomain(value: unknown): string {
  const raw = trim(String(value ?? ''));
  return REGEX_URL.test(raw) ? raw.replace(/https?:\/\//, '') : raw;
}
